import { defineMessages } from 'react-intl';

export const metadataDefinitions = defineMessages({
  mandatoryTitle: {
    id: 'estimationDetail.tab.metadata.mandatoryTitle',
    defaultMessage: 'Mandatory Master Data',
  },
  optionalTitle: {
    id: 'estimationDetail.tab.metadata.optionalTitle',
    defaultMessage: 'Optional Master Data',
  },
  progressSentenceFormattedWithAmountPercentage: {
    id: 'estimationDetail.tab.metadata.progressSentenceFormattedWithAmountPercentage',
    defaultMessage: '{amountPercentage}% of mandatory information has been provided.',
  },
  aiAdvisoryDocumentLinkLabel: {
    id: 'estimationDetail.tab.metadata.aiAdvisoryDocumentLinkLabel',
    defaultMessage: 'AI Advisory Link',
  },
  unsavedChangesTitle: {
    id: 'estimationDetail.tab.metadata.unsavedChangesTitle',
    defaultMessage: 'Unsaved Changes',
  },
  unsavedChangesWarning: {
    id: 'estimationDetail.tab.metadata.unsavedChangesWarning',
    defaultMessage:
      'You have unsaved changes in the Master Data form. Do you want to save them before leaving?',
  },
  unsavedChangesSave: {
    id: 'estimationDetail.tab.metadata.unsavedChangesSave',
    defaultMessage: 'Save and leave',
  },
  unsavedChangesDiscard: {
    id: 'estimationDetail.tab.metadata.unsavedChangesDiscard',
    defaultMessage: 'Discard and leave',
  },
  unsavedChangesCancel: {
    id: 'estimationDetail.tab.metadata.unsavedChangesCancel',
    defaultMessage: 'Cancel',
  },
  unsavedChangesValidationError: {
    id: 'estimationDetail.tab.metadata.unsavedChangesValidationError',
    defaultMessage:
      'Some mandatory fields are missing or invalid. Please fill them in before saving.',
  },
});
